import {Authenticated, NotAuthenticated, UserAccsessList} from './AccountingActions'

const authInitState = {
    isAuthorize : false,
    currentUser: '',
    AccessList: []
    // AccessList: localStorage.getItem('accessList') !== null ? localStorage.getItem('accessList').split(','): []
}

const handleAuth = (state = authInitState, action) =>{
    switch (action.type) {
        case Authenticated:
            return {...state, isAuthorize: true}
        case NotAuthenticated:
            return {...state, isAuthorize: false, AccessList: []}
        case UserAccsessList:
            return {...state, AccessList: action.data}
        default:
            return state
    }
}

export default handleAuth;